import { render, staticRenderFns } from "./RequirementDetail.vue?vue&type=template&id=039e91ba&scoped=true"
import script from "./RequirementDetail.vue?vue&type=script&lang=js"
export * from "./RequirementDetail.vue?vue&type=script&lang=js"
import style0 from "./RequirementDetail.vue?vue&type=style&index=0&id=039e91ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039e91ba",
  null
  
)

export default component.exports